/**
 * Formeya nav — eski menü flaşını önle (bfcache + stale CDN).
 */
(function () {
  var STALE = ['Schlafzimmer', 'Marke', 'Service']
  var RELOAD_KEY = 'fm-nav-stale-reload'

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return
    var path = location.pathname.replace(/\/$/, '') || '/'
    if (path === '/') location.reload()
  })

  function markReady() {
    document.documentElement.classList.add('fm-nav-ready')
  }

  function hasStaleDesktopNav() {
    var titles = []
    document.querySelectorAll('.header-menu .menu-list__link-title').forEach(function (el) {
      titles.push((el.textContent || '').trim())
    })
    if (
      STALE.some(function (label) {
        return titles.indexOf(label) !== -1
      })
    ) {
      return true
    }
    var uberLinks = document.querySelectorAll(
      '[data-menu-grid-id="MegaMenuList-6"] a.mega-menu__link',
    )
    if (uberLinks.length > 4) return true
    var html = document.documentElement.innerHTML
    if (html.indexOf('formeya-nav:v19') === -1 && html.indexOf('formeya-nav:v18') === -1) {
      var path = location.pathname.replace(/\/$/, '') || '/'
      if (path === '/') return true
    }
    return false
  }

  function boot() {
    if (hasStaleDesktopNav()) {
      if (!/\btype=/.test(location.search) && !sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, '1')
        var q = location.search ? location.search + '&' : '?'
        location.replace(location.pathname + q + 'type=' + Date.now() + location.hash)
        return
      }
    }
    markReady()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  window.setTimeout(markReady, 1200)
})()
